import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {HandoverListItem} from "@handover/view-models/handover-list-item";
import {VehicleListItem} from "@handover/view-models/vehicle-list-item";
import {HandoverNotificationsService} from "@handover/routes/main-route/services/handover-notifications.service";
import {
  HandoverLimitedAccessModalComponent
} from "@handover/routes/main-route/components/vehicle-handovers-list/components/handover-limited-access-modal/handover-limited-access-modal.component";
import {DialogService} from "@shared/services/dialog.service";

@Component({
  selector: 'handovermod-vehicle-handovers-list',
  templateUrl: './vehicle-handovers-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleHandoversListComponent implements OnInit {

  @Input() selectedVehicle?: VehicleListItem;
  @Input() handovers?: HandoverListItem[];

  private selectedItem?: HandoverListItem;

  constructor(
    private handoverNotificationsService: HandoverNotificationsService,
    private dialogService: DialogService
  ) {
  }

  ngOnInit(): void {
  }

  isItemSelected(item: HandoverListItem): boolean {
    return this.selectedItem?.handoverGivenId === item.handoverGivenId &&
      this.selectedItem.handoverReturnId === item.handoverReturnId;
  }

  onSelect(handover: HandoverListItem) {
    if (handover.isCreatedOnDesktop) {
      this.dialogService.open(HandoverLimitedAccessModalComponent);
    }

    const ifClickeOtherProtocol = this.selectedItem?.tokenQR !== handover.tokenQR;
    if (ifClickeOtherProtocol) {
      this.selectedItem = handover;
      this.handoverNotificationsService.selectedHandoverChanged$.next(this.selectedItem);
    }
  }
}
